import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import styled from 'styled-components';
import Img from 'gatsby-image';
import Layout from '../components/layout';
import ArrowIcon from '../../static/images/arrow-fa.svg'
import OhCleoLogo from '../../static/images/shareable.jpg'

const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  background: var(--third-color);
  padding-bottom: 80px;

  i {
    font-style: italic;
    font-family: 'DM Sans Italic';
  }

  .permalink {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 100;
  }
`;

const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, 320px);
  justify-content: center;
  column-gap: 70px;
  row-gap: 70px;
  padding: 80px 170px;

  & > li {
    text-align: center;
  }

  @media screen and (max-width: 1200px) {
    padding: 30px 110px;
  }
  @media screen and (max-width: 768px) {
    padding: 30px 0;
  }
`;

const ListItem = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  color: var(--light-600);
  flex: 1;

  & h4 {
    color: var(--light-green);
    margin-top: 24px;
    line-height: 27px;
    
  }

  .excerpt{
    padding: 16px;
  }

  .featured {
    object-fit: cover;
    height: 400px;
    width: 320px;
    border-radius: 2px;
  }

  & a {
    text-decoration: none;
  }

  .read-more {
    margin-top: 8px;
    color: var(--light-color);
    font-family: 'DM SANS', sans-serif;
  }
`;

const FirstItem = styled.div`
  position: relative;
  display: grid;
  grid-gap: 120px;
  grid-template-columns: 2fr 1fr;
  min-height: 500px;
  margin: 40px 170px 80px 0;
  grid-template-areas: 'image text';

  .left {
    grid-area: image;
  }
  .right {
    grid-area: text;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin-top: 80px;

    /* & h2 {
      font-size: 45px;
    } */

    & > li {
      margin-bottom: 0;
    }

    .posted-on {
      color: var(--light-800);
      font: var(--font-bodytext-2);
    }
    .excerpt {
      color: var(--light-600);
    }

    & h2 {
      color: var(--light-color);
    }

    .read-more {
      position: relative;
      top: -7%;
      align-self: flex-end;
      color: var(--light-color);
      font-family: 'DM SANS', sans-serif;
    }

    .content {
      & :nth-child(n) {
        margin-bottom: 40px;
      }
    }

    & a {
      text-decoration: none;
    }
  }

  @media screen and (max-width: 1040px) {
    margin: 40px 100px 40px 0;
  }

  @media screen and (max-width: 900px) {
    margin: 100px 0 100px 0;
    grid-template-columns: unset;
    row-gap: 40px;
    grid-template-areas:
      'text'
      'image';

    .right {
      margin: 30px;
    }
    .left {
      margin-right: 80px;
    }
  }

  @media screen and (max-width: 499px) {
    .left {
      margin-right: 30px;
    }
    .posted-on {
      padding-bottom: 16px;
    }
  }
`;

const Blog = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulBlogPost(sort: { fields: publishedDate, order: DESC }) {
          edges {
            node {
              title
              id
              slug
              publishedDate
              excerpt {
                childMarkdownRemark {
                  excerpt(pruneLength: 150)
                }
              }
              featuredImage {
                fluid(maxWidth: 1000) {
                  src
                  sizes
                  aspectRatio
                  srcSet
                }
              }
            }
          }
        }
      }
    `,
  );

 let reducedArray = data.allContentfulBlogPost.edges.filter((item) => {
    return new Date(item.node.publishedDate) < Date.now()
  });

  
  const [first, ...rest] = reducedArray
  return (
    <Layout showDarkStyling={true}>
      <Wrapper>
        <FirstItem>
          <Link className="permalink" to={`/blog/${first.node.slug}/`} />
          <div className="left">
            {first.node.featuredImage && first.node.featuredImage.fluid ? (
              <Img
                style={{ borderRadius: '0px 8px 8px 0px' }}
                fluid={first.node.featuredImage.fluid}
                alt={first.node.title}/>
            ) : (
              <img style={{width: "90%", marginTop: "2rem"}}
              src={OhCleoLogo}
              alt="OhCleo Logo"/>
            )}
          </div> 
          <div className="right">
          <div />
            <div className="content">
              <p className="posted-on">Posted on {new Date(first.node.publishedDate).toLocaleString('en-US', {month: 'long', day: "2-digit", year: "numeric" })}</p>
              <h2>{first.node.title}</h2>
              <p className="excerpt">
                {first.node.excerpt.childMarkdownRemark.excerpt}
              </p>
            </div>
            <div className="read-more">Read more <span><img src={ArrowIcon}/></span></div>
          </div>
        </FirstItem>
        <List>
          {rest.map(edge => (
            <ListItem key={edge.node.id}>
              <Link className="permalink" to={`/blog/${edge.node.slug}/`} />
              {edge.node.featuredImage && edge.node.featuredImage.fluid ? (
                <Img
                  className="featured"
                  fluid={edge.node.featuredImage.fluid}
                  alt={edge.node.title}
                />
              ) : (
                <img style={{width: "320px"}}
                src={OhCleoLogo}
                alt="OhCleo Logo"
              />
              )}
              <h4 className="title">{edge.node.title}</h4>
              <p className="excerpt">
                {edge.node.excerpt.childMarkdownRemark.excerpt}
              </p>
              <div className="read-more">Read more <span><img src={ArrowIcon}/></span></div>
            </ListItem>
          ))}
        </List>
      </Wrapper>
    </Layout>
  );
};

export default Blog;
